module.exports = __webpack_public_path__ + "img/BG4-icon.17e3eae0.png";